<template>
  <span class="button-group">
    <div class="row" v-if="syncing">
      <loader></loader>
    </div>
    <div v-else>
      <router-link class="btn btn-default btn-sm"
                   :to="{name: this.consultType, params: {client_id: consult.client, season: consultSeason}}">
        Open
      </router-link>
      |
      <button class="btn btn-sm btn-success"
              @click="canSubmit ? submitConsult() : ''"
              :class="{disabled: !canSubmit}"
              v-tooltip="getSubmitTooltip"
              :title="getSubmitTooltip">
        Submit
      </button>
      |
      <VDropdown style="display: inline"   :offset="[0, 16]" >

        <button class="btn btn-sm btn-default tooltip-target b3"
                v-tooltip="'More Options'"
                title="More Options">
          <span class="glyphicon glyphicon-option-vertical"></span>
        </button>

        <template #popper>
          <ul class="nav nav-pills nav-stacked">
            <li>
              <button class="btn btn-default btn-block"
                      @click="backup"
                      v-tooltip="'Make a backup of entered data'">
                Send Diagnostic
              </button>
            </li>
            <li>

              <button class="btn btn-sm btn-danger btn-block"
                      v-tooltip="'Delete local copy of the Consult'"
                      @click="confirmDeleteConsult">
                Delete
              </button>
            </li>
          </ul>
        </template>
      </VDropdown>
    </div>
  </span>
</template>

<script>

import currentConsult from "@/_store/current_consult.module";
import generalFarmConsult from '@/_store/general_farm_consult.module';
import { consultFormService } from '@/_services';
import { indexedDB } from '@/_helpers'
import { mapActions, mapGetters, mapState } from 'vuex'
import { unslugify } from '@/_helpers/utils'

export default {
  name: "GeneralFarmConsultActions",
  props: ['consult', 'consultSeason'],
  data() {
    return {
      syncing: false,
      consultType: 'general_farm_consult',
    }
  },
  methods: {
    ...mapActions('client', ['updateClientLastConsult']),
    submitConsult: function() {
      // set currentConsult store
      Object.assign(currentConsult.state, generalFarmConsult.stateMixin);
      Object.assign(currentConsult.actions, generalFarmConsult.actionsMixin);
      Object.assign(currentConsult.mutations, generalFarmConsult.mutationsMixin);
      Object.assign(currentConsult.getters, generalFarmConsult.gettersMixin);

      if (this.$store.hasModule("currentConsult")) {
        this.$store.unregisterModule("currentConsult")
      }
      this.$store.registerModule("currentConsult", currentConsult);


      this.$store.commit('currentConsult/setConsultType', 'generalFarmConsult')
      this.syncing = true
      let self = this

      let consultParams = { clientId: this.consult.client, season: this.consultSeason }

      this.$store.dispatch('currentConsult/setClient', this.consult.client).then(() => {
        self.$store.dispatch('currentConsult/saveConsultData', consultParams).then(
          () => {
            self.$store.dispatch('alert/success', {
              message: 'Success! Data has been synced to the server.'
            });
            self.deleteConsult()

            let fullConsultData = {
              season_start_year: self.$moment(self.consult.models.Misc.consult_opened_date).year(),
              consult_opened_date: self.consult.models.Misc.consult_opened_date,
              consult_type_slug: self.consultType,
              consult_type: unslugify(self.consultType),
            }
            self.updateClientLastConsult({
              clientId: Number(self.consult.client),
              consultData: fullConsultData
            })
          }).catch(error => {
            if (error.response.status == 500) {
              self.$store.dispatch('alert/error', {
                message: 'An error occurred. Contact the administrator.'
              })
              let hideAlert = true
              self.backup(hideAlert)
            } else {
              if ( error.response.data['consult_already_finished'] ) {
                self.$store.dispatch('alert/error', {message: 'Consult already finished.'});
                self.consult.models.Misc.read_only = true
                // TODO: store data on idb?
              } else {
                self.$store.dispatch('currentConsult/addBackendErrors', {
                  clientId: self.consult.client,
                  errors: error.response.data
                }).then(() => {
                  self.$router.push({
                    name: 'general_farm_consult',
                    params: { client_id: self.consult.client, season: self.consultSeason, }
                  })
                })
              }
            }
          }
          )
          .finally(() => { self.syncing = false })
      })
    },
    backup: function(hideAlert) {
      // TODO: maybe add a consult type to indexedDB on backend
      this.syncing = true

      consultFormService.consultBackup(this.consult, this.consult.client)
        .then(() => {
          if (!hideAlert) {
            this.$store.dispatch('alert/success', {message: 'Data has been synced to the backup server.'})
          }
        })
        .catch(() => {
          if (!hideAlert) {
            this.$store.dispatch('alert/error', {message: 'An error occurred. Contact the administrator.'});
          }
        })
        .finally(() => { this.syncing = false })
    },
    deleteConsult: function ()
    {
      var self = this
      var dbKey = this.consult.client
      var consultData = {client: this.consult.client, consultType: this.consultType}

      indexedDB.delete(dbKey, 'general-farm-consult').then(() => {
        self.$emit('consult-deleted', consultData)
      })
    },
    confirmDeleteConsult: function ()
    {
      if(confirm("Do you really want to delete?"))
      {
        this.deleteConsult()
      }
    }
  },
  computed: {
    ...mapState('currentConsult', ['backendErrors']),
    ...mapGetters('connection', ['online']),
    canSubmit: function ()
    {
        // TODO: check for actual conditions
      return Boolean(this.online &&
        !this.consult.models.Misc.read_only &&
        this.consult.models.Disclaimer.signed_at)
    },
    getSubmitTooltip: function ()
    {
      if (!this.online) {
        return "Please wait until you're online to submit"
      } else if (this.consult.models.Misc.read_only) {
        return "Consult is in read only mode"
      } else if (!this.consult.models.Disclaimer.signed_at) {
            return "Please complete required fields and sign the consult"
      }
      return null
    }
  },
}
</script>

